import { Link } from "wouter";

const B2B_GUIDE_PATH = "/b2b-lead-generation-strategies-best/";

export default function B2BLeadGenerationGuideLink() {
  return (
    <section className="mt-10 border border-[#00D4AA]/25 bg-[#00D4AA]/[0.04] p-5 sm:p-6" aria-labelledby="b2b-lead-generation-guide-link">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#00D4AA]">B2B growth guide</p>
      <h2 id="b2b-lead-generation-guide-link" className="font-serif text-xl text-white">
        Generate More Qualified B2B Leads: 7 UK Strategies
      </h2>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-300">
        Build a shared operating model for ICP definition, buying-group content, paid and organic acquisition, sales acceptance, and pipeline measurement.
      </p>
      <Link href={B2B_GUIDE_PATH} className="mt-4 inline-flex text-sm font-semibold text-[#00D4AA] hover:text-teal-200">
        Read the B2B lead generation guide →
      </Link>
    </section>
  );
}
